import { render, staticRenderFns } from "./DentalOffices.vue?vue&type=template&id=c457fcd0&scoped=true"
import script from "./DentalOffices.vue?vue&type=script&lang=ts"
export * from "./DentalOffices.vue?vue&type=script&lang=ts"
import style0 from "./DentalOffices.vue?vue&type=style&index=0&id=c457fcd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c457fcd0",
  null
  
)

export default component.exports